var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":_vm.title,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":_vm.fetchRoute,"reportTypeCode":_vm.reportTypeCode,"permission":_vm.permission},on:{"onResponse":function($event){return _vm.$emit('onResponse', $event)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }